import React, { useEffect, useRef } from 'react';

/** A proportional-font, auto-growing textarea styled like an email compose area. */
const AutoGrowTextarea = React.forwardRef(function AutoGrowTextarea({ value, onChange, className = '', minRows = 12, maxRows = 40, style, ...rest }, forwardedRef) {
  const innerRef = useRef(null);
  const ref = (node) => {
    innerRef.current = node;
    if (typeof forwardedRef === 'function') forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };
  useEffect(() => {
    const el = innerRef.current;
    if (!el) return;
    el.style.height = 'auto';
    const lineHeight = 24; // approximate — matches leading-relaxed with base font
    const min = minRows * lineHeight;
    const max = maxRows * lineHeight;
    const desired = Math.min(max, Math.max(min, el.scrollHeight));
    el.style.height = desired + 'px';
  }, [value, minRows, maxRows]);
  return (
    <textarea
      ref={ref}
      value={value}
      onChange={onChange}
      className={`w-full resize-y bg-[#0a0a0b] border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:ring-2 focus:ring-[#d4a94a] focus:border-transparent px-4 py-3 text-[15px] leading-relaxed ${className}`}
      style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", ...style }}
      {...rest}
    />
  );
});

export default AutoGrowTextarea;
